import React, { FC, memo, useMemo } from 'react'
import { useRouter } from 'next/router'
import { Container } from '@ucheba/ui/components/Container/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Aside } from '@ucheba/ui/components/Aside/desktop'
import { Logo } from '@ucheba/ui/components/Logo/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { Box } from '@ucheba/ui/components/Box/desktop'
import { Banner } from '../../../Banner/desktop'
import { forAbiturients } from '../../../../routs'
import { useEventsListItemCore, useEventsListItemDate } from '../../../EventsList/bll'
import { IEventPageProps } from '../../types'
import { useEmbedVideoUrl } from '../../bll'
import EventsInstitution from '../../components/EventsInstitution/desktop/EventsInstitution'
import EventsContent from '../../components/EventsContent/desktop/EventsContent'
import EventsAnother from '../../components/EventsAnother/desktop/EventsAnother'
import { uchebaName } from '../../constants'

const IFrame = styled.iframe`
  border-radius: ${sv.radius.large};
`

const BoxST = styled(Box)`
  color: ${sv.color.gray40};
  padding-left: ${sv.spacing.large};
`

const EventPageFinished: FC<IEventPageProps> = (props) => {
  const { directVkStreamUrl } = useEventsListItemCore(props)
  const { date, format } = useEventsListItemDate(props)
  const { query } = useRouter()

  const {
    institution,
    name,
    streamUrl,
    content,
    pathname,
    eventsSearchPath,
    bannerProgramTypes,
    bannersBlock,
  } = props

  const params = useMemo(() => {
    if (query['programTypes[]']) {
      return query
    }

    if (!bannerProgramTypes) return undefined

    return {
      ...query,
      programTypes: bannerProgramTypes,
    }
  }, [query, bannerProgramTypes])

  const embedUrlYoutube = useEmbedVideoUrl(streamUrl)

  const newDate = date?.split(',')

  return (
    <>
      <Container>
        <Spacing spacing='xlarge' />

        <Grid as='main'>
          <GridCol uxs={24}>
            <Grid as='div'>
              <GridCol uxs={5} as='aside'>
                {institution ? (
                  <Aside>
                    <EventsInstitution {...institution} />
                  </Aside>
                ) : (
                  <Aside>
                    <Logo color='blue' width='80px' isSquare />

                    <Spacing spacing='small' />

                    <Heading
                      h4={uchebaName}
                      href={forAbiturients.school.path}
                      color='blue'
                    />
                  </Aside>
                )}
              </GridCol>

              <GridCol uxs={14} as='article'>
                <Heading h1='Мероприятие уже завершено' />

                <Spacing spacing='xxsmall' />

                <Heading h3={name} color='gray40' />

                {directVkStreamUrl || embedUrlYoutube ? (
                  <>
                    <Spacing spacing='large' />

                    <IFrame
                      width='100%'
                      height='375'
                      src={directVkStreamUrl || embedUrlYoutube}
                      title='YouTube video player'
                      frameBorder='0'
                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                      allowFullScreen
                    />

                    <Spacing spacing='xxlarge' />
                  </>
                ) : (
                  <Spacing spacing='uxlarge' />
                )}

                {content && (
                  <>
                    <EventsContent content={content} />

                    <Spacing spacing='xxlarge' />
                  </>
                )}

                {institution && !bannersBlock && <Banner id={4} extraParams={params} />}

                <Spacing spacing='uxlarge' />
              </GridCol>

              <GridCol uxs={5} as='aside'>
                <BoxST spacing='null'>
                  {date && (
                    <>
                      {newDate && newDate[0] && (
                        <div style={{ fontWeight: 'bold' }}>{newDate[0]}</div>
                      )}

                      <Spacing spacing='usmall' />

                      {newDate && newDate[0] && (
                        <div style={{ fontWeight: 'bold' }}>{newDate[1]}</div>
                      )}

                      <Spacing spacing='usmall' />
                    </>
                  )}

                  {format && (
                    <>
                      <Text>{format}</Text>

                      <Spacing spacing='usmall' />
                    </>
                  )}
                </BoxST>
              </GridCol>
            </Grid>

            <Grid as='div'>
              <GridCol uxs={5} as='aside' />

              <GridCol uxs={14} as='article'>
                <EventsAnother pathname={pathname} eventsSearchPath={eventsSearchPath} />
              </GridCol>

              <GridCol uxs={5} as='aside' />
            </Grid>
          </GridCol>
        </Grid>

        <Spacing spacing='uxlarge' />
      </Container>

      {institution && !bannersBlock && (
        <>
          <Banner id={6} extraParams={params} />
          <Banner id={14} extraParams={params} />
        </>
      )}
    </>
  )
}

export default memo(EventPageFinished)
